import { useState } from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  Portal,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';

import type { CampaignType } from '../types';

type Props = {
  campaign: CampaignType;
  handleClose: () => void;
};

const ConfirmStartCampaignDialog = ({ campaign, handleClose }: Props) => {
  const [loading, setLoading] = useState(false);

  const onStartClick = async () => {
    setLoading(true);

    try {
      const response = await api.post(`/campaign/${campaign.id}/start`);

      if (response.status === 200) {
        toast.success('Campanha iniciada com sucesso.');
        handleClose();
      }
    } catch (error) {
      toast.error('Erro ao iniciar campanha. Tente novamente!');
      datadogRum.addError(new Error('Fail to start campaign'), {
        error,
        campaignId: campaign.id,
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja iniciar o atendimento da campanha
                {' '}
                {campaign.name}
                {' '}
                do portfólio
                {' '}
                {campaign.portfolio.name}
                ?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" disabled={loading}>Cancelar</Button>
              </Dialog.ActionTrigger>
              <Button bg="green.700" color="white" onClick={onStartClick} loading={loading}>
                Iniciar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmStartCampaignDialog;
